import { centerOpener } from '@flipster/utils/opener';

import { symbolNameToInfo } from '../misc/helper';
import { Button } from './button';
import FullscreenIcon from './icons/fullscreen-icon.svg';
import { useTvHeaderContext } from './index';

export const Fullscreen = () => {
  const tv = useTvHeaderContext();

  return (
    <Button
      onClick={() => {
        const { symbol } = symbolNameToInfo(tv.symbol);
        centerOpener(`/fullchart/${symbol}`, '_blank', window.outerWidth, window.outerHeight);
      }}
      tooltip='Open fullscreen chart'
    >
      <FullscreenIcon width={20} height={20} />
    </Button>
  );
};
